import { useDeviceType } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './CarouselContainer.css';
import { ETestId } from '../../../common/constants';
import { IDailyRentOfferForMobileSite } from '../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { Carousel, EPessimizationBackground, IPessimization } from '../../components/OfferCard/components/Carousel';
import { PhotoFeatureIcons } from '../../components/OfferCard/components/Carousel/components/PhotoFeatureIcons';

interface ICarouselContainerProps {
  offer: Pick<IDailyRentOfferForMobileSite, 'photoFeatureIcons' | 'media' | 'moderationInfo' | 'features'>;
  offerLink: string;
  extraControls?: React.ReactNode;
  containerClassName?: string;
  className?: string;
  onSlideChange?(): void;
  onClick?(): void;
}

export const CarouselContainer = ({
  extraControls,
  offer,
  offerLink,
  containerClassName,
  className,
  onSlideChange,
  onClick,
}: ICarouselContainerProps) => {
  const { media: offerMedia, photoFeatureIcons, moderationInfo } = offer;
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';
  const containerRef = React.useRef<HTMLDivElement | null>(null);

  const { features } = offer;
  const mainImageAlt = [features.objectType, features.totalArea, features.floorInfo].filter(Boolean).join(',');

  const pessimizationRaw = moderationInfo?.photoStub || null;
  const featureIcons = <PhotoFeatureIcons photoFeatureIcons={photoFeatureIcons} />;

  const pessimization = React.useMemo<IPessimization | undefined>(() => {
    if (!pessimizationRaw?.text) {
      return undefined;
    }

    return {
      background:
        (pessimizationRaw?.background as unknown as EPessimizationBackground) || EPessimizationBackground.Gray,
      text: pessimizationRaw.text,
    };
  }, [pessimizationRaw]);

  return (
    <div className={cn(styles['carousel-container'], containerClassName)} ref={containerRef}>
      {extraControls}
      <a
        className={cn(styles['carousel'], className)}
        href={offerLink}
        onClick={onClick}
        target="_blank"
        rel="noreferrer"
        id="listing-modal-carousel"
        data-linkname="link_to_card"
        data-testid={ETestId.CardGalleryWrapperLink}
      >
        <Carousel
          containerRef={containerRef}
          desktopControls={isDesktop}
          slotSliderEnd={featureIcons}
          media={offerMedia}
          pessimization={pessimization}
          onSlideChange={onSlideChange}
          mainImageAlt={mainImageAlt}
        />
      </a>
    </div>
  );
};
